import { render, staticRenderFns } from "./Signal.vue?vue&type=template&id=19401931&scoped=true"
import script from "./Signal.vue?vue&type=script&lang=js"
export * from "./Signal.vue?vue&type=script&lang=js"
import style0 from "./Signal.vue?vue&type=style&index=0&id=19401931&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19401931",
  null
  
)

export default component.exports